
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';
import eventBus from '@/utils/eventBus';
import { groupPushList, addGroupPush, editGroupPush, delGroupPush } from '@/api/group';

import GroupSearch from './components/GroupSearch.vue';
import DialogDept from '@/components/DeptDialog/index.vue';
import GroupStep2 from './components/GroupStep2.vue';
import DialogScheduling from '@/components/DialogScheduling/index.vue';

@Component({
  name: 'GroupsPushCombine',
  components: {
    GroupSearch,
    DialogDept,
    GroupStep2,
    DialogScheduling
  }
})
export default class extends Vue {
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private formSearch:any = {};
  private tableData:any = [];
  private listLoading = false;
  private isDef=false;
  private selectedDept:any={}
  private pushName=''
  private pushId=''

  created() {
    let that = this;
    eventBus.$on('groupSearch', (data:any) => {
      that.formSearch = data;
      this.getList();
    });

    this.$once('hook:beforeDestroy', () => {
      eventBus.$off('groupSearch');
    });

    this.getList();
  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private getList() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      group_type: 7,
      customer_name: this.formSearch.customer,
      address_name: this.formSearch.address,
      servicer_dept_name: this.formSearch.dept,
      engineer_user_name: this.formSearch.engineer,
      fault_phenomenon_name: this.formSearch.fault,
      tag_name: this.formSearch.tags,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    groupPushList(params)
      .then((res: any) => {
        let data = res.data;
        if (data !== null) {
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].one = [];
            this.tableData[i].spare = [];
            this.tableData[i].two = [];
            if (this.tableData[i].group_push && this.tableData[i].group_push.where_one) {
              if (this.tableData[i].group_push.where_one.customer_list && this.tableData[i].group_push.where_one.customer_list.length > 0) {
                for (let cus of this.tableData[i].group_push.where_one.customer_list) {
                  this.tableData[i].one.push({
                    one_name: cus.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_one.address_list && this.tableData[i].group_push.where_one.address_list.length > 0) {
                for (let add of this.tableData[i].group_push.where_one.address_list) {
                  if (add.province_name) {
                    add.address = add.province_name;
                  }
                  if (add.city_name) {
                    add.address = add.city_name;
                  }
                  if (add.district_name) {
                    add.address = add.district_name;
                  }
                  this.tableData[i].one.push({
                    one_name: add.address
                  });
                }
              }
              if (this.tableData[i].group_push.where_one.fault_phenomenon_list && this.tableData[i].group_push.where_one.fault_phenomenon_list.length > 0) {
                for (let fault of this.tableData[i].group_push.where_one.fault_phenomenon_list) {
                  this.tableData[i].one.push({
                    one_name: fault.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_one.tag_list && this.tableData[i].group_push.where_one.tag_list.length > 0) {
                for (let tag of this.tableData[i].group_push.where_one.tag_list) {
                  this.tableData[i].one.push({
                    one_name: tag.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_one.department_list && this.tableData[i].group_push.where_one.department_list.length > 0) {
                for (let dept of this.tableData[i].group_push.where_one.department_list) {
                  this.tableData[i].one.push({
                    one_name: dept.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_one.device_list && this.tableData[i].group_push.where_one.device_list.length > 0) {
                for (let device of this.tableData[i].group_push.where_one.device_list) {
                  this.tableData[i].one.push({
                    one_name: device.name
                  });
                }
              }
            }
            if (this.tableData[i].group_push && this.tableData[i].group_push.where_two) {
              if (this.tableData[i].group_push.where_two.customer_list && this.tableData[i].group_push.where_two.customer_list.length > 0) {
                for (let cus of this.tableData[i].group_push.where_two.customer_list) {
                  this.tableData[i].two.push({
                    two_name: cus.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_two.address_list && this.tableData[i].group_push.where_two.address_list.length > 0) {
                for (let add of this.tableData[i].group_push.where_two.address_list) {
                  if (add.province_name) {
                    add.address = add.province_name;
                  }
                  if (add.city_name) {
                    add.address = add.city_name;
                  }
                  if (add.district_name) {
                    add.address = add.district_name;
                  }
                  this.tableData[i].two.push({
                    two_name: add.address
                  });
                }
              }
              if (this.tableData[i].group_push.where_two.fault_phenomenon_list && this.tableData[i].group_push.where_two.fault_phenomenon_list.length > 0) {
                for (let fault of this.tableData[i].group_push.where_two.fault_phenomenon_list) {
                  this.tableData[i].two.push({
                    two_name: fault.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_two.tag_list && this.tableData[i].group_push.where_two.tag_list.length > 0) {
                for (let tag of this.tableData[i].group_push.where_two.tag_list) {
                  this.tableData[i].two.push({
                    two_name: tag.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_two.department_list && this.tableData[i].group_push.where_two.department_list.length > 0) {
                for (let dept of this.tableData[i].group_push.where_two.department_list) {
                  this.tableData[i].two.push({
                    two_name: dept.name
                  });
                }
              }
              if (this.tableData[i].group_push.where_two.device_list && this.tableData[i].group_push.where_two.device_list.length > 0) {
                for (let device of this.tableData[i].group_push.where_two.device_list) {
                  this.tableData[i].two.push({
                    two_name: device.name
                  });
                }
              }
            }
            if (this.tableData[i].one) {
              if (this.tableData[i].two && this.tableData[i].one.length > this.tableData[i].two.length) {
                for (let index = 1; index < this.tableData[i].one.length; index++) {
                  const element = this.tableData[i].one[index];
                  let data:any = {};
                  data.one_name = element.one_name;
                  if (index < this.tableData[i].two.length) {
                    data.two_name = this.tableData[i].two[index].two_name;
                  }
                  this.tableData[i].spare.push(data);
                }
              } else if (this.tableData[i].two) {
                for (let index = 1; index < this.tableData[i].two.length; index++) {
                  const element = this.tableData[i].two[index];
                  let data:any = {};
                  data.two_name = element.two_name;
                  if (index < this.tableData[i].one.length) {
                    data.one_name = this.tableData[i].one[index].one_name;
                  }
                  this.tableData[i].spare.push(data);
                }
              } else {
                for (let index = 1; index < this.tableData[i].one.length; index++) {
                  const element = this.tableData[i].one[index];
                  let data:any = {};
                  data.one_name = element.one_name;
                  this.tableData[i].spare.push(data);
                }
              }
            } else {
              for (let index = 1; index < this.tableData[i].two.length; index++) {
                const element = this.tableData[i].two[index];
                let data:any = {};
                data.two_name = element.two_name;
                this.tableData[i].spare.push(data);
              }
            }
          }
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.tableData = [];
        this.pagination.total = 0
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  //= =========================新版
  private dialogGroupStepVisible = false
  private groupPushType: any = {
    type: 7,
  }
  private selectedGroupData(val: any) {
    this.getList();
  }
  private closeGroupStepVisible(val: any) {
    this.dialogGroupStepVisible = val
  }
  //= ============================

  // private groupCombineVisible = false
  // private selectedDeptvisible = false

  private selectPopData:any={};

  private addDefOperationhandle() {
    this.isDef = true;
    this.editorData = {};
    this.dialogGroupStepVisible = true;

    // this.pushName = '';
    // this.deptSelected = {};
    // this.selectedDept = {};
    // this.pushId = '';
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入2-30位由数字、字母、中文组成的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,30}$/,
    //   inputValue: this.pushName
    // }).then(({ value }: any) => {
    //   this.pushName = value;
    //   this.selectedDeptvisible = true;
    // }).catch(() => {
    // });
  }
  private addOperationhandle() {
    this.isDef = false;
    this.editorData = {};
    this.dialogGroupStepVisible = true;

    // this.selectedDept = {};
    // this.pushName = '';
    // this.pushId = '';
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入2-30位由数字、字母、中文组成的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,30}$/,
    //   inputValue: this.pushName
    // }).then(({ value }: any) => {
    //   this.pushName = value;
    //   this.groupCombineVisible = true;
    // }).catch(() => {
    // });
  }
  private editorData:any=''
  private operationhandle(val: any) {
    this.editorData = val;
    this.isDef = parseInt(val.is_default_group) === 1;
    this.dialogGroupStepVisible = true;

    // this.pushId = val.id;
    // this.pushName = val.group_name;
    // if (val.group_push) {
    //   if (parseInt(val.sub_type) === 1) {
    //     this.deptSelected.dept_id = val.group_push.servicer_dept_id;
    //     this.deptSelected.name = val.group_push.servicer_dept_name;
    //   } else {
    //     this.selectedDept = val.group_push;
    //   }
    // }
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入2-30位由数字、字母、中文组成的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,30}$/,
    //   inputValue: this.pushName
    // }).then(({ value }: any) => {
    //   this.pushName = value;
    //   if (this.isDef) {
    //     this.selectedDeptvisible = true;
    //   } else {
    //     this.groupCombineVisible = true;
    //   }
    // }).catch(() => {
    // });
  }
  // private closeGroupCombineVisible(val: any) {
  //   this.getList();
  //   this.groupCombineVisible = val;
  // }
  // private closeGroupCombineTwoVisible(val: any) {
  //   this.getList();
  //   this.selectedDeptvisible = val;
  // }
  // private groupCombineNextVisible(val: any) {
  //   this.selectPopData = val;
  //   this.selectedDeptvisible = true;
  // }

  // 排班
  private nextSchedulingHandle(val:any) {
    this.selectPopData = val;
    this.departmentVisible = true;
  }
  private departmentVisible=false;
  private deptType=2
  private deptSelected:any={};
  private dialogResultSchedulingHandle:any={}

  private departmentDialogClose(val:any) {
    this.departmentVisible = val;
  }
  private departmentSelected(val:any) {
    this.deptSelected = val;
    this.selectPopData.servicer_dept_id = val.dept_id;
    this.selectPopData.servicer_dept_name = val.name;
    this.add(this.pushName, this.isDef, 1);
  }

  private groupCombineNextTwoVisible(val: any) {
    this.selectPopData.servicer_dept_id = val.servicer_dept_id;
    this.selectPopData.servicer_dept_name = val.servicer_dept_name;
    this.selectPopData.engineer_user_id = val.engineer_user_id;
    this.selectPopData.engineer_user_name = val.engineer_user_name;
    this.add(this.pushName, this.isDef, 0);
  }

  private userMore = false;
  private userMoreLoading = false;
  private userPage = 1;
  private multipleUserSelection: any = [];
  private multipleDeptSelection: any = [];

  private add(name: any, isDefault:boolean, subType:number) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      servicer_company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      servicer_company_name: UserModule.getCompanyName,
      group_type: 7,
      sub_type: subType
    };
    if (this.selectPopData) {
      if (this.selectPopData.customer && this.selectPopData.customer.length > 0) {
        params.customer_list = JSON.stringify(this.selectPopData.customer);
      }
      if (this.selectPopData.address && this.selectPopData.address.length > 0) {
        params.address_list = JSON.stringify(this.selectPopData.address);
      }
      if (this.selectPopData.fault && this.selectPopData.fault.length > 0) {
        params.fault_phenomenon_list = JSON.stringify(this.selectPopData.fault);
      }
      if (this.selectPopData.tags && this.selectPopData.tags.length > 0) {
        params.tag_list = JSON.stringify(this.selectPopData.tags);
      }
      if (this.selectPopData.dept && this.selectPopData.dept.length > 0) {
        params.department_list = JSON.stringify(this.selectPopData.dept);
      }
      if (this.selectPopData.device && this.selectPopData.device.length > 0) {
        params.device_list = JSON.stringify(this.selectPopData.device);
      } else {
        params.device_list = '';
      }
      params.where_one = this.selectPopData.oneWhere;
      params.where_two = this.selectPopData.twoWhere;
      if (this.selectPopData.servicer_dept_id) {
        params.servicer_dept_id = this.selectPopData.servicer_dept_id;
        params.servicer_dept_name = this.selectPopData.servicer_dept_name;
      }
      if (this.selectPopData.engineer_user_id) {
        params.engineer_user_id = this.selectPopData.engineer_user_id;
        params.engineer_user_name = this.selectPopData.engineer_user_name;
      }
    }
    params.group_name = name;
    params.is_default_group = isDefault ? '1' : '0';
    if (this.pushId) {
      params.id = this.pushId;
      editGroupPush(params).then(res => {
        if (subType === 1) {
          this.dialogSchedulingVisible = true;
          this.groupData = {
            group_push_id: this.pushId,
            group_push_name: this.pushName
          };
        } else {
          this.showSuccessMsg((res as any).msg);
          // this.groupCombineVisible = false;
          // this.selectedDeptvisible = false;
          this.getList();
        }
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addGroupPush(params).then(res => {
        if (subType === 1) {
          if (res.data && res.data.group_cs) {
            this.pushId = res.data.group_cs.id;
          }
          this.dialogSchedulingVisible = true;
          this.groupData = {
            group_push_id: this.pushId,
            group_push_name: this.pushName
          };
        } else {
          this.showSuccessMsg((res as any).msg);
          // this.groupCombineVisible = false;
          // this.selectedDeptvisible = false;
          this.getList();
        }
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  // 设置排班
  private setSchedulinghandle(val:any) {
    this.editorData = val;
    this.pushId = val.id;
    this.isDef = parseInt(val.is_default_group) === 1;
    this.pushName = val.group_name;
    if (val.group_push) {
      if (parseInt(val.sub_type) === 1) {
        this.deptSelected.dept_id = val.group_push.servicer_dept_id;
        this.deptSelected.name = val.group_push.servicer_dept_name;
      } else {
        this.selectedDept = val.group_push;
      }
    }
    this.groupData = {
      group_push_id: this.pushId,
      group_push_name: this.pushName
    };
    this.dialogSchedulingVisible = true;
  }
  // 排班 弹窗
  private dialogSchedulingVisible=false
  private groupData:any={}

  private dialogSchedulingConfirm(val:any) {
    this.dialogSchedulingVisible = false;
    this.departmentVisible = false;
    // this.groupCombineVisible = false;
    this.getList();
  }

  private dialogSchedulingClose(val:boolean) {
    this.dialogSchedulingVisible = val;
  }

  // private edit(name: any, id:any) {
  //   const params = {
  //     user_id: UserModule.getUserId,
  //     company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //     id: id,
  //     groupName: name,
  //     group_state: '1',
  //     push_type: '',
  //     dynamicTagsDept: [],
  //     dynamicTagsPeople: []
  //   };
  //   // 报修维修类型 10服务部门推送 11维修工程师推送
  //   // if (parseInt(this.radioDeptStaff) === 10) {
  //   //   // 部门
  //   //   params.push_type = '10';
  //   //   params.dynamicTagsDept = this.multipleDeptSelection;
  //   // } else {
  //   //   // 人员
  //   //   params.push_type = '11';
  //   //   params.dynamicTagsPeople = this.multipleUserSelection;
  //   // }
  // }

  private deleteGroupPush(val: any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          id: val.id
        };
        delGroupPush(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
